import * as React from 'react';
import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {Dialogs} from './types';

interface FooterProps {
    onSubmit: (event: React.MouseEvent<HTMLButtonElement>) => void,
    onHide: () => void
    disabled: boolean
}

const Footer = ({onSubmit, onHide, disabled = false}: FooterProps) => {
    return (
        <div>
            <Button disabled={disabled} label='Отправить' className='p-button-success' onClick={onSubmit} />
            <Button label='Закрыть' className='p-button-info' onClick={onHide} />
        </div>
    )
}

interface State {
    comment: string
}

interface Props extends Dialogs {
    onSubmit: (comment: string) => void
}

export class AdminRequestDialog extends React.Component<Props, State> {
    state = {
        comment: ''
    }

    handleTextarea = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        this.setState({comment: event.currentTarget.value})
    }

    handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        this.props.onSubmit(this.state.comment);
    }

    render() {
        const { visible, onHide } = this.props
        const { comment } = this.state

        return (
            <Dialog
                header='Сообщение администратору'
                className='custom-dialog'
                visible={visible}
                onHide={onHide}
                closable={false}
                draggable={false}
                style={{maxWidth: '700px', width: '100%'}}
                footer={Footer({
                    onSubmit: this.handleSubmit,
                    onHide,
                    disabled: !comment.length
                })}
            >
                <div className='form-group'>
                    <textarea
                        className='form-control'
                        value={comment}
                        onChange={this.handleTextarea}
                        placeholder={'Введите сообщение администратору'}
                    />
                </div>
            </Dialog>
        );
    }
}

